export default {
  printSalesRegisterPerMonth(data) {
    return axios.post(`${ import.meta.env.VITE_SITE_URL }/bookkeepings/evidences/sales-register-per-month-print`, data);
  },
  printPurchasesRegisterPerMonth(data) {
    return axios.post(`${ import.meta.env.VITE_SITE_URL }/bookkeepings/evidences/purchase-register-per-month-print`, data);
  },
  printPurchasesRegisterPerRatePerMonth(data) {
    return axios.post(`${ import.meta.env.VITE_SITE_URL }/bookkeepings/evidences/purchase-register-tax-per-rate-print`, data);
  },
  getVatRegisterTypes() {
    return axios.get(`${ import.meta.env.VITE_SITE_URL }/bookkeepings/vat-register-types`, { params: { list: true } });
  },
};
